import { useState, useEffect } from 'react';
import axios from 'axios';
import { FormattedWearableData } from '@/types/wearable';

export const useWearableData = (timeFilter: string = '24h') => {
  const [data, setData] = useState<FormattedWearableData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get('/api/wearables/data');
        
        // Filter data based on timeFilter
        const now = new Date();
        const filteredData = response?.data?.filter((item: FormattedWearableData) => {
          const itemDate = new Date(item.date);
          const diffInHours = (now.getTime() - itemDate.getTime()) / (1000 * 60 * 60);
          
          switch (timeFilter) {
            case '24h':
              return diffInHours <= 24;
            case '7d':
              return diffInHours <= 168; // 7 * 24
            case '30d':
              return diffInHours <= 720; // 30 * 24
            case '1y':
              return diffInHours <= 8760; // 365 * 24
            default:
              return true;
          }
        });

        setData(filteredData);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch wearable data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [timeFilter]);

  return { data, loading, error };
};